const CLIENT_ID = process.env.VUE_APP_UBER_CLIENT_ID

export function buildUberLink(pickup, dropoff) {
  const params = new URLSearchParams()
  if (CLIENT_ID) params.set('client_id', CLIENT_ID)
  params.set('pickup', JSON.stringify({
    latitude: pickup.lat,
    longitude: pickup.lng,
    ...(pickup.name && { addressLine1: pickup.name }),
  }))
  params.append('drop[0]', JSON.stringify({
    latitude: dropoff.lat,
    longitude: dropoff.lng,
    ...(dropoff.name && { addressLine1: dropoff.name }),
  }))
  return `https://m.uber.com/looking?${params.toString()}`
}
